// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"537":"css/admin-app.6881","1572":"css/app.6881"}[chunkId] + ".css";
};